import React, { useCallback } from 'react';
import { useQueryFetch } from '@ace/react-utilities';
import styles from 'assets/css/SMARTGoal.module.css';
import logo from 'assets/images/logo-white.svg';
import { IconCheckmarkCircle, IconAngleRight } from '@ace/react-icons';
import { useSMARTGoalPageState, useSMARTGoalPageNavigation, useSMARTGoalAppProps } from 'context/SMARTGoalAppContext';
import { queryProps, useSMARTGoalStepState } from 'Components/SMARTGoal/SMARTGoalHelper';
import classNames from 'classnames';
import { withCardLinkIconWrap } from 'Components/Card/CardLink';

const IconAngleRightWrap = withCardLinkIconWrap(IconAngleRight);

const SMARTGoalProgress = (props) => {
    const { data: { Pages, ProgramTitle, maxSteps } } = useQueryFetch(queryProps.appSteps.componentName, queryProps.appSteps.retrievalUrl, {
        select: useCallback((data) => ({
            Pages: data.Pages.map(page => ({ Step: page.Step, Title: page.Title })),
            ProgramTitle: data.ProgramTitle,
            maxSteps: data.TotalGoals
        }), [])
    });

    const { showWelcome } = useSMARTGoalPageState();

    return (
        <div>
            <div className={styles['sg-progress--desktop']}>
                <div className={styles['sg-progress__header']}>
                    <img className={styles['sg-progress__header-logo']} src={logo} alt="logo" />
                </div>
                <div className={styles['sg-progress__program-container']}>
                    <div className={styles['sg-progress__program-header']}> {/* header */}
                        <h3 className={styles['sg-progress__program-title']}>{ProgramTitle}</h3>
                        <p className={styles['sg-progress__program-subtitle']}>Set your goals for each component of this program:</p>
                    </div>
                    <div className={styles['sg-progress__program-body']}> {/* program steps container */}
                        <div className={styles['sg-progress__program-body--inner']}> {/* program steps container inner */}
                            <ul>
                                {Pages.map(page => (<SMARTGoalProgressStep stepCnt={page.Step} stepTitle={page.Title} />))}
                                <SMARTGoalProgressStep stepCnt={(maxSteps + 1)} stepTitle="Review" />
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {!showWelcome && <SMARTGoalProgressMobile/>} 
        </div>
    );
}

export default SMARTGoalProgress;

const SMARTGoalProgressMobile = () => {
    const { currentStepIndex } = useSMARTGoalStepState();
    const { maxSteps } = useSMARTGoalAppProps();
    const { data: pages } = useQueryFetch(queryProps.appSteps.componentName, queryProps.appSteps.retrievalUrl, {
        select: useCallback((data) => (data.Pages.map(page => ({ Step: page.Step, Title: page.Title }))), [])
    });
    const { prevPage, nextPage } = useSMARTGoalPageNavigation();

    const page = currentStepIndex > -1 ? pages[currentStepIndex] : { Step: maxSteps + 1, Title: 'Review'};

    return (
        <div className={styles['sg-progress--mobile']}>
            <div className={styles['sg-progress__program-container--mobile']}>
                <div className={`${styles['sg-progress__program-nav']} ${styles['sg-progress__program-nav--previous']}`}>
                    <span className={styles.backButton} onClick={() => prevPage()}>
                        <IconAngleRightWrap />
                    </span>
                </div>
                <div className={styles['sg-progress__program-header']}> {/* header */}
                    <span className={styles['sg-progress__step-number']}>{page.Step}</span>
                    <span className={styles['sg-progress__program-title']}>{page.Title}</span>
                </div>
                {currentStepIndex !== -1 && <div className={`${styles['sg-progress__program-nav']} ${styles['sg-progress__program-nav--forward']}`}>
                    <span onClick={() => nextPage()}>
                        <IconAngleRightWrap />
                    </span>
                </div>}
            </div>
        </div>
    );
}

const SMARTGoalProgressStep = ({ stepCnt, stepTitle }) => {
    const { currentPage, maxSteps } = useSMARTGoalPageState();
    const { setPage } = useSMARTGoalPageNavigation();
    const { data: checked } = useQueryFetch(queryProps.userGoals.componentName, queryProps.userGoals.retrievalUrl, {
        select: useCallback((data) => (stepCnt <= maxSteps ? data.Goals[stepCnt - 1].Populated : false), [maxSteps, stepCnt])
    });
    const isActive = currentPage - 1 === stepCnt;

    const classes = classNames(styles['sg-progress__step-container'], {
        [`${styles['sg-progress__step-container--active']}`]: isActive,
        //[`${styles['sg-progress__step-container--checked']}`]: checked,
    });

    return (
        <li>
            <div className={classes} onClick={() => setPage(stepCnt + 1)}>
                {!checked && <span className={styles['sg-progress__step-number']}>{stepCnt}</span>}
                {checked && <span className={styles['sg-progress__step-container--checked']}><IconCheckmarkCircle fill="#fff" /></span>}
                <span className={styles['sg-progress__step-title']}>{stepTitle}</span>
            </div>
        </li>
    );

}
